export default __webpack_public_path__ + "static/media/ldap.620326ef.svg";